<template>
  <SmallSquare class="" content='1、微信图文可用于群发、自动回复、自定义菜单、一对一回复等。
  2、在公众号后台创建的微信图文不会自动同步到高大永恒塑料制品有限公司后台，需要手动操作同步。
  3、受微信公众平台限制，微信图文素材和微信图片总数上限为5000，高级图文不在此限制范围。'></SmallSquare>
  <div class="s_flex_bian_c m-t-25">
    <a-button type="primary" v-has:drewManagementCreate="()=> {$router.push('/wxPublic/wxManagement/drewManagement/wx_imgText_add?type=add')}">
      <PlusOutlined />
      新建微信图文
    </a-button>
    <div class="s_flex_ali">
      <a-input v-model:value="search.keyword" style="width: 300px;" placeholder="请输入关键词进行搜索" />
      <a-button class="m-l-15" type="primary" @click='onSearch'>搜索</a-button>
    </div>
  </div>
  <a-spin :spinning="listLoading">
    <div class="m-t-25 s_bor_cbed s_bor10 s_over_h s_borList" v-if='msgList.length > 0'>
      <div class="p-t-15 p-b-15 p-l-20 p-r-20 s_flex_bian_c s_bb1 s_borListItem" v-for='item in msgList' :key='item'>
        <div class="width40 s_flex_ali">
          <img class="width-100 height-100 m-r-20" :src="info.picdomain+'/'+item.list[0].image" alt="" >
          <p class="s_c333 s_omit width30">{{item.list[0].title}}</p>
        </div>
        <p class="s_c999 flex_1">{{item.create_time}}</p>
        <div class="width18 s_flex_bian_c">
          <a class="flex_1 text_ac" href="javascript:;" v-has:drewManagementEdit="()=>edit(item)">编辑</a>
          <a class="flex_1 text_ac" href="javascript:;" v-has:drewManagementDel="()=>del(item)">删除</a>
          <a class="flex_1 text_ac" href="javascript:;" v-has:drewManagementCopyUrl="()=>showCopy(item)">复制链接</a>
        </div>
      </div>
    </div>
    <div v-if="msgList.length==0" class='p-50'>
      <a-empty :description="false" />
    </div>
  </a-spin>
  <a-pagination :style="{marginTop:'25px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
  <a-modal  :keyboard="false" title="复制链接" :width='700' centered :footer="null" v-model:visible="visible" destroyOnClose>
    <p class="s_c333">链接地址：<span class="s_c999">可将链接复制到需要用到的地方</span></p>
    <div class="s_bf7 s_flex_bian_c bor-rad-5 p-6 m-t-25" v-for="(v,k) in copyData.list" :key="k">
      <p class="width40 s_omit">{{v.title}}</p>
      <a-input v-model:value="v.wx_url" class="width45" />
      <a-button type="primary" @click="copy(v.wx_url)">复制</a-button>
    </div>
  </a-modal>
</template>
<script>
import { PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { getWxGraphic, wxGraphicDel } from "@/api/public_wx";
import store from "@/store";
let defSearch = {
  page: 1,
  limit: 10,
  keyword: "",
};
export default {
  name: "wxImgText",
  components: { PlusOutlined },
  setup(props) {
    const search = ref({ ...defSearch });
    const state = reactive({
      visible: false,
      listLoading: false,
      total: 1,
      msgList: [],
      info: store.state.user.info,
      copyData: [],
    });
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 搜索
    const onSearch = () => {
      search.value.page = 1;
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const data = ref([]);
    const initData = async (values) => {
      state.listLoading = true;
      let res = await getWxGraphic(values).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        state.msgList = res.data.data;
        state.total = res.data.total;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    // 删除
    const del = (data) => {
      $Modal.confirm({
        centered: true,
        content: "删除后该图文将无法恢复，您确定要删除该图文吗？",
        onOk: async () => {
          let res = await wxGraphicDel({ id: data.id }).then((res) => res.data);
          if (iscode(res, true)) {
            initData(search.value);
          }
        },
      });
    };
    const showCopy = (data) => {
      state.visible = true;
      state.copyData = data;
    };
    // 复制
    const copy = (link) => {
      var input = document.createElement("input"); // 直接构建input
      input.value = link; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      message.success("复制成功");
    };
    // 修改
    const edit=(data)=>{
     $router.push({path:"/wxPublic/wxManagement/drewManagement/wx_imgText_add",query:{type:'edit',id:data.id}})
    }
    return {
      ...toRefs(state),
      search,
      pageCurrentChange,
      pageSizeChange,
      onSearch,
      del,
      copy,
      showCopy,
      edit
    };
  },
};
</script>